import { ActionIconGroup, CloseIcon, EditIcon, SaveIcon, TrashIcon } from "@atlas-design-system/react";

export function actionButtons(info) {
    const isEditing = info.table.options.editableRowIndex === info.row.index;
    return (<ActionIconGroup style={{ justifyContent: 'flex-end', flexWrap: 'unset' }}
        actions={[
            {
                key: 'editOrSave',
                //disabled: !info.table.options.meta.saveEditButtonStatus,
                icon: isEditing ? <SaveIcon /> : <EditIcon />,
                action: () => {
                    if (isEditing) {
                        info.table.options.meta.updateRecord(info.row.index);
                    } else {
                        info.table.options.setEditableRowIndex(info.row.index);
                    }
                },
                tooltip: isEditing ? 'Save changes' : 'Edit this row'
            },
            {
                key: 'deleteOrCancel',
                icon: isEditing ? <CloseIcon /> : <TrashIcon />,
                action: () => {
                    if (isEditing) {
                        info.table.options.setEditableRowIndex(null);
                        info.table.options.meta.cellsValidationData = [];
                    } else {
                        //delete record from storage....
                        info.table.options.setEditableRowIndex(null);
                        info.table.options.meta.removeRecord(info.row.original);
                    }
                },
                tooltip: isEditing ? 'Cancel' : 'Delete this row'
            }
        ]} />);
}
